onDomLoad(($dom) => {
  $dom
    .find("[data-behaviour='unlock-account-numbers']")
    .each(function (index, el) {
      el.addEventListener('click', () => {
        const url = el.getAttribute('data-url')
        window.modalCitizen.openModal('unlock-account-numbers-modal', {
          url: url,
        })
      })
    })
})
